// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import positionPaperProposedWordingEntity from './entities/position-paper-proposed-wording.json';
import positionPaperProposedWordingMenu from '../pages/position-paper-proposed-wording/menu.json';
import positionPaperProposedWordingFullForm from '../pages/position-paper-proposed-wording/forms/full.json';
import positionPaperProposedWordingContextForm from '../pages/position-paper-proposed-wording/forms/context.json';
import positionPaperProposedWordingMiniForm from '../pages/position-paper-proposed-wording/forms/mini.json';
import positionPaperProposedWordingLookupForm from '../pages/position-paper-proposed-wording/forms/lookup.json';
import positionPaperProposedWordingTableView from '../pages/position-paper-proposed-wording/views/table.json';
import positionPaperProposedWordingCardsView from '../pages/position-paper-proposed-wording/views/cards.json';
import positionPaperProposedWordingDashboardView from '../pages/position-paper-proposed-wording/views/dashboard.json';

/** Тип запису «Пропонована редакція» зі сторінками пакета: меню, форми та подання з pages/position-paper-proposed-wording/. */
export const positionPaperProposedWordingDefinition: IRecordTypeDefinition = {
  ...positionPaperProposedWordingEntity,
  views: assembleViewSet({
      table: positionPaperProposedWordingTableView,
      cards: positionPaperProposedWordingCardsView,
      dashboard: positionPaperProposedWordingDashboardView,
  }),
  form: positionPaperProposedWordingFullForm,
  forms: { full: positionPaperProposedWordingFullForm, context: positionPaperProposedWordingContextForm, mini: positionPaperProposedWordingMiniForm, lookup: positionPaperProposedWordingLookupForm },
  menu: positionPaperProposedWordingMenu,
} as IRecordTypeDefinition;
